/**
 * Narrowing predicates for a union the caller already holds; the parameter
 * type is that union, so the predicate refines evidence rather than
 * inventing it.
 */
export function isString<T>(value: T): value is T & string {
  return typeof value === "string";
}

export function isNumber<T>(value: T): value is T & number {
  return typeof value === "number";
}
